<div class="termianls-details-view-container" *ngIf="terminalsObject" fxLayout="column" fxLayoutGap="15px"  >

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + terminalsObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="terminalsObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button *ngIf="(userPermissions | async).terminals.write" [disabled]="!(userPermissions | async).terminals.write || terminalsObject.status.key!==TERMINAL_STATUS_TO_BE_REALIZED " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button *ngIf="(userPermissions | async).terminals.delete" [disabled]="!(userPermissions | async).terminals.delete " (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
    <button *ngIf="(userPermissions | async).terminals.write" [disabled]="!(userPermissions | async).terminals.write " (click)="terminalImportRowChange()" mat-stroked-button color="primary"><mat-icon>edit</mat-icon> <span> Zmiana transakcji</span></button>
    <button
      *ngIf=" (userPermissions | async)?.terminals.delete && terminalsObject.status.key === TERMINAL_STATUS_TO_BE_REALIZED "
      [disabled]="!(userPermissions | async).terminals.delete"
      mat-stroked-button (click)="statusChange(TERMINAL_STATUS_PAID)" color="primary"
    ><span>Zapłacona</span></button>
    <button
      *ngIf="(userPermissions | async)?.terminals.delete && terminalsObject.status.key === TERMINAL_STATUS_TO_BE_REALIZED "
      [disabled]="!(userPermissions | async).terminals.delete"
      mat-stroked-button (click)="statusChange(TERMINAL_STATUS_SUSPENDED)" color="primary"
    ><span>Wstrzymana</span></button>
    <button
      *ngIf="(userPermissions | async)?.terminals.delete && terminalsObject.status.key !== TERMINAL_STATUS_TO_BE_REALIZED"
      [disabled]="!(userPermissions | async).terminals.delete"
      mat-stroked-button (click)="statusChange(TERMINAL_STATUS_TO_BE_REALIZED)" color="primary"
    ><span>Do zrealizowania</span></button>
    <button   [disabled]="!(userPermissions | async)?.terminals.create" mat-stroked-button color="primary"
              class="add-button" (click)="addNote()"><mat-icon>add</mat-icon> Dodaj notatkę</button>

    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>edit</span></button>

  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100"  fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
        <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
          <mat-card >
            <div fxLayout="row"  fxLayoutGap="15px">
              <h3>Dane</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="TU" [value]="terminalsObject.insuranceCompany?.name"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer polisy" [value]="terminalsObject.policyNumber"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer rachunku bankowego" [value]="terminalsObject.accountNumber"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Kwota"[value]="">{{(terminalsObject.sum === null ? 0 : terminalsObject.sum) | number:'1.2-2'}} zł</app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="terminalsObject.note">
              <div fxFlex="100">
                <app-detail header="Powód zmiany statusu polisy" [value]="terminalsObject.note "></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%"   fxLayoutGap="15px">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Notatki</h3>
            </div>
            <div  *ngFor="let note of terminalsObject?.terminalsNote">

              <div fxFlex="100" fxLayout="row">
                <app-detail fxFlex="100" header="{{note.createdAt  | date:'y-MM-dd HH:mm' }} {{note.createdBy.firstName}}  {{note.createdBy.lastName}}"  [value]="note?.note"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
        <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
          <mat-card >
            <div fxLayout="row">
              <h3>Struktura</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="terminalsObject.partner?.fullName"   [link]="terminalsObject.partner ? ['/partnerzy/szczegoly', terminalsObject.partner.uuid] : undefined"></app-detail>
              </div>
            </div>
            <div fxLayout="row">
              <h3>Grupa polis</h3>
            </div>
            <div fxLayout="row" >
              <div fxFlex="100">
                <app-detail header="Numer grupy" [value]="terminalsObject.terminalsGroup?.uuid"></app-detail>
              </div>
            </div>
            <div fxLayout="row" >
              <div fxFlex="100">
                <app-detail header="Kwota">
                  {{(terminalsObject.terminalsGroup?.sum === null ? 0 : terminalsObject.terminalsGroup?.sum) | number:'1.2-2'}} zł
                </app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
        <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
          <mat-card >
            <div fxLayout="row">
              <h3>Transakcja</h3>
            </div>

            <div fxLayout="row" >
              <div fxFlex="50">
                <app-detail header="Numer transakcji" [value]="terminalsObject.terminalsImportRow?.id"  [link]="terminalsObject.terminalsImportRow ? ['/terminale/transakcje/szczegoly/', terminalsObject.terminalsImportRow.uuid] : undefined"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Kwota">
                  {{(terminalsObject.terminalsImportRow?.transferAmount === null ? 0 : terminalsObject.terminalsImportRow?.transferAmount) | number:'1.2-2'}} zł
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>
  </div>
</div>
